import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { UpdateNoticeParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  UpdateNoticeRepository,
  UpdateNoticeResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum UpdateNoticeState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: UpdateNoticeState;
  message: string;
}

const initialState: InitialState = {
  status: UpdateNoticeState.initial,
  message: "",
};

export const updateNotice = createAsyncThunk(
  "updateNotice",
  async (param: UpdateNoticeParam, { rejectWithValue }) => {
    try {
      const response: UpdateNoticeResponse = await UpdateNoticeRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const updateNoticeSlice = createSlice({
  name: "updateNotice",
  initialState,
  reducers: {
    resetUpdateNotice: (state) => {
      state.status = UpdateNoticeState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateNotice.pending, (state) => {
        state.status = UpdateNoticeState.inProgress;
      })
      .addCase(updateNotice.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = UpdateNoticeState.success;
          state.message = message;
        }
      })
      .addCase(updateNotice.rejected, (state, action) => {
        state.status = UpdateNoticeState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectUpdateNotice = (state: RootState) => state.updateNotice;
export const { resetUpdateNotice } = updateNoticeSlice.actions;
export default updateNoticeSlice.reducer;
